import { render, staticRenderFns } from "./SuccessNotif.vue?vue&type=template&id=2d0da0ae"
import script from "./SuccessNotif.vue?vue&type=script&lang=js"
export * from "./SuccessNotif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports